import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PartiesPage from "./pages/PartiesPage";
import ProductsPage from "./pages/ProductsPage";
import UsersPage from "./pages/UsersPage";
import CompanyPage from "./pages/CompanyPage";
import SettingsPage from "./pages/SettingsPage";
import InventoryPage from "./pages/InventoryPage";
import Gstr1ReportPage from "./pages/Gstr1ReportPage";
import Gstr3bReportPage from "./pages/Gstr3bReportPage";
import BankReconciliationPage from "./pages/BankReconciliationPage";
import PurchaseBillUploadPage from "./pages/PurchaseBillUploadPage";
import AccountingPage from "./pages/AccountingPage";
import TallyImportPage from "./pages/TallyImportPage";
import AuditPage from "./pages/AuditPage";
import OutstandingReportPage from "./pages/OutstandingReportPage";
import StockSummaryPage from "./pages/StockSummaryPage";
import PayablesReportPage from "./pages/PayablesReportPage";
import InwardBillsPage from "./pages/InwardBillsPage";
import SalesReportPage from "./pages/SalesReportPage";
import ReportsHubPage from "./pages/ReportsHubPage";
import PublicInvoicePage from "./pages/PublicInvoicePage";
import DocumentsListPage from "./pages/DocumentsListPage";
import DocumentFormPage from "./pages/DocumentFormPage";
import DocumentViewPage from "./pages/DocumentViewPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/public/invoice/:token" element={<PublicInvoicePage />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/customers" element={<PartiesPage kind="customer" />} />
            <Route path="/vendors" element={<PartiesPage kind="vendor" />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/users" element={<ProtectedRoute requireAdmin><UsersPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute requireAdmin><SettingsPage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute requireAdmin><ReportsHubPage /></ProtectedRoute>} />
            <Route path="/reports/sales" element={<ProtectedRoute requireAdmin><SalesReportPage /></ProtectedRoute>} />
            <Route path="/reports/gstr1" element={<ProtectedRoute requireAdmin><Gstr1ReportPage /></ProtectedRoute>} />
            <Route path="/reports/gstr3b" element={<ProtectedRoute requireAdmin><Gstr3bReportPage /></ProtectedRoute>} />
            <Route path="/reconciliation" element={<ProtectedRoute><BankReconciliationPage /></ProtectedRoute>} />
            <Route path="/purchase-bill-upload" element={<ProtectedRoute><PurchaseBillUploadPage /></ProtectedRoute>} />
            <Route path="/accounting" element={<ProtectedRoute><AccountingPage /></ProtectedRoute>} />
            <Route path="/tally-import" element={<ProtectedRoute requireAdmin><TallyImportPage /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute requireAdmin><AuditPage /></ProtectedRoute>} />
            <Route path="/reports/outstanding" element={<ProtectedRoute requireAdmin><OutstandingReportPage /></ProtectedRoute>} />
            <Route path="/reports/stock-summary" element={<ProtectedRoute requireAdmin><StockSummaryPage /></ProtectedRoute>} />
            <Route path="/reports/payables" element={<ProtectedRoute requireAdmin><PayablesReportPage /></ProtectedRoute>} />
            <Route path="/inward-bills" element={<ProtectedRoute requireAdmin><InwardBillsPage /></ProtectedRoute>} />
            {/* Document routes */}
            <Route path="/:docPath" element={<DocumentsListPage />} />
            <Route path="/:docPath/new" element={<DocumentFormPage mode="new" />} />
            <Route path="/:docPath/:id" element={<DocumentViewPage />} />
            <Route path="/:docPath/:id/edit" element={<DocumentFormPage mode="edit" />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
